import React, { useState } from 'react';
import axios from 'axios';
import { UserController } from 'api';
import moment from 'moment';
import { featureEnabled, featureFlagClient } from 'utils';
import Loading from '../../react-common/Loading';
import Empty from '../../react-common/Empty';
import BuyerAppointmentsPage from './BuyerAppointmentsPage';
import BuyerAppointmentPrint from './BuyerAppointmentPrint';
import { BuyerAppointments } from './types';

type BuyerAppointmentsPDFProps = {
  $location: any;
};

const BuyerAppointmentsPDF: React.FC<BuyerAppointmentsPDFProps> = ({
  $location,
}) => {
  const [appointments, setAppointments] = useState<BuyerAppointments>([]);
  const [hasConfirmedAppointments, setHasConfirmedAppointments] =
    useState<boolean>(false);
  const [isDataLoading, setIsDataLoading] = useState<boolean>(false);
  const [showAccessInfo, setShowAccessInfo] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>('');

  const handleCheck = () => {
    setShowAccessInfo(prevShowAccessInfo => !prevShowAccessInfo);
  };

  const fetch = async () => {
    const { date, dateFrom, dateTo, preferences, searchText } =
      $location.search();

    setIsDataLoading(true);
    // TODO: Remove when removing SupraRebrandingFeature flag.
    await featureFlagClient.initialize();
    const [{ data: fetchedAppointments }, user] = await Promise.all([
      axios.get<BuyerAppointments>('/user/coop/appointments/searchByDate', {
        params: {
          statuses: preferences?.split(','),
          dateFrom: moment(dateFrom).startOf('day').toISOString(),
          dateTo: dateTo
            ? moment(dateTo).endOf('day').toISOString()
            : undefined,
          date,
          searchText,
        },
      }),
      UserController.current(),
    ]);

    setAppointments(fetchedAppointments);
    setHasConfirmedAppointments(
      fetchedAppointments.some(appointment => appointment.status === 'confirm'),
    );
    // @ts-ignore
    setUserName(`${user.firstName} ${user.lastName}`);
    setIsDataLoading(false);
  };

  React.useEffect(() => {
    fetch();
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
      {
        // eslint-disable-next-line no-nested-ternary
        isDataLoading ? (
          <Loading size="fa-5x" />
        ) : appointments.length === 0 ? (
          <Empty text="No upcoming showings" />
        ) : (
          <>
            <BuyerAppointmentsPage
              appointments={appointments}
              showAccessInfo={showAccessInfo}
              userName={userName}
              hasSupraRebrandingFeature={featureEnabled(
                'supraRebrandingFeature',
                1,
              )}
            />
            <BuyerAppointmentPrint
              handleCheck={handleCheck}
              hasConfirmedAppointments={hasConfirmedAppointments}
            />
          </>
        )
      }
    </div>
  );
};

export default BuyerAppointmentsPDF;
